// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderBottomOutlinedSvg from "@fishx/icons-svg/es/asn/BorderBottomOutlined";
import FishxIcon from '../components/FishxIcon';

var BorderBottomOutlined = function BorderBottomOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderBottomOutlinedSvg
  }));
};

BorderBottomOutlined.displayName = 'BorderBottomOutlined';
export default React.forwardRef(BorderBottomOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BorderBottomOutlined.js
// module id = 2085
// module chunks = 0